import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface RaceSummaryCaptionPropsType {
    variant: DefaultComponentVariantType | null;
}


const setRaceSummaryCaption = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            border-radius: ${theme.star.radius.small};
        `;
    }
    return css`
        border: 1px solid ${theme.star.raceSummary.borderColor};
    `;
};

/* Table caption and cells */
export const RaceSummaryCaption = withConfig(theme => styled('li', { label: 'RaceSummaryCaption' })<RaceSummaryCaptionPropsType>`
    ${({ variant }): SerializedStyles => setRaceSummaryCaption(variant, theme)};
    background: ${theme.star.raceSummary.bgColorSecondary};
    color: ${theme.star.raceSummary.txtColorTertiary};
    display: flex;
    flex-flow: row nowrap;
    font-size: ${theme.star.fontSize.xSmall};
    justify-content: space-between;
    line-height: 1.4;
`);
